module.exports = __webpack_public_path__ + "img/banner1-4.df453326.png";